var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTr = function SvgTr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h42.667v32H0V0z",
    fill: "#F31930"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.132 16.498c0 4.414-3.64 7.993-8.13 7.993S10.87 20.914 10.87 16.5 14.51 8.505 19 8.505s8.132 3.578 8.132 7.993z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.538 16.498c0 3.53-2.912 6.394-6.505 6.394s-6.505-2.863-6.505-6.394 2.912-6.394 6.505-6.394 6.505 2.863 6.505 6.394z",
    fill: "#F31830"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.715 12.764l-.066 2.955-2.757.747 2.717.968-.066 2.71 1.772-2.117 2.678.93-1.55-2.272 1.89-2.258-2.9.8-1.72-2.464z",
    fill: "#FFF"
  })));
};
export default SvgTr;